import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FolderCheck } from 'lucide-react';
import { api } from '@/lib/api';

/** Shown on the evaluated home ONLY when the user has been granted WR editor access. */
export const MeWrEntryCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get('/wr/my-access')
      .then((r) => { if (alive && r.data?.enabled && r.data?.can_edit) setEnabled(true); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!enabled) return null;
  return (
    <Card className="p-6 flex items-center gap-4" data-testid="me-wr-entry-card">
      <div className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
        <FolderCheck className="h-5 w-5 text-primary" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-base font-semibold">Workforce Records</p>
        <p className="text-sm text-muted-foreground">{t('wr.meEntryHint')}</p>
      </div>
      <Button className="rounded-full shrink-0" onClick={() => navigate('/me/workforce-records')} data-testid="me-wr-entry-btn">
        {t('wr.meEntryOpen')}
      </Button>
    </Card>
  );
};
